// extracted by mini-css-extract-plugin
export default {"_404":"Unauthorized__404__NC294","btn":"Unauthorized_btn__-VXR1"};